// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"de6ec789","320":"c0bd6780","953":"06698d9a"}[chunkId] + ".chunk.js";
};